export interface NavigationItem {
  name: string;
  label: string;
  route: string;
  icon?: string;
  allowedPermissions?: string[];
  order?: number;
  hasAlert?: boolean;
}

export interface NavigationCategory {
  name: string;
  label: string;
  icon?: string;
  allowedPermissions?: string[];
  order?: number;
  items: NavigationItem[];
}

export const NAVIGATION_CONFIG: NavigationCategory[] = [
  {
    name: "dashboard",
    label: "dashboard",
    icon: "HomeIcon",
    order: 1,
    allowedPermissions: [
      "admin:super",
      "risk-score:read",
      "dashboard:view",
      "incidents:read",
    ],
    items: [
      {
        name: "dashboard",
        label: "dashboard",
        route: "/dashboard",
        icon: "ChartBarIcon",
        allowedPermissions: ["dashboard:view"],
        order: 1,
      },
      {
        name: "situation-room",
        label: "situationroom",
        route: "/situation-room",
        icon: "ChartBarIcon",
        allowedPermissions: ["dashboard:view"],
        order: 4,
      },
      {
        name: "report",
        label: "reports",
        route: "/dashboard-report",
        icon: "ChartBarIcon",
        allowedPermissions: ["incidents:read", "incidents:read:own"],
        order: 2,
      },
      {
        name: "risk-report",
        label: "report",
        route: "/risk-report",
        icon: "ChartBarIcon",
        allowedPermissions: ["admin:super", "risk-score:read"],
        order: 3,
      },
    ],
  },
  {
    name: "role",
    label: "caseManagement",
    icon: "HomeIcon",
    order: 2,
    allowedPermissions: [
      "feedback:read",
      "feedback:create",
      "incidents:read",
      "incidents:update",
    ],
    items: [
      {
        name: "Conflict",
        label: "conflicts",
        route: "/incident/reports",
        icon: "IncidentIcon",
        allowedPermissions: ["incidents:read", "incidents:read:own"],
        order: 1,
      },
      {
        name: "feedback",
        label: "feedbacks",
        route: "/incident/feedback",
        icon: "FeebackIcon",
        allowedPermissions: ["feedback:read", "feedback:create"],
        order: 3,
      },
      {
        name: "triangulation",
        label: "triangulation",
        route: "/triangulation",
        icon: "TriangulationIcon",
        allowedPermissions: [
          "triangulations:finalize",
          "triangulations:read",
          "triangulations:recommend",
          "triangulations:start",
        ],
        order: 4,
      },
      {
        name: "internal-list",
        label: "publicReport",
        route: "/internal/list-report",
        icon: "ChartBarIcon",
        allowedPermissions: ["reports:create", "reports:read"],
        order: 5,
      },
    ],
  },
  {
    name: "analysis",
    label: "Analysis",
    icon: "ChartPieIcon",
    order: 3,
    allowedPermissions: ["analysis:read"],
    items: [
      {
        name: "analysis-dashboard",
        label: "Dashboard",
        route: "/analysis-dashboard",
        icon: "ChartBarIcon",
        allowedPermissions: ["analysis:read"],
        order: 1,
      },
    ],
  },
];
